import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type ValidationErrorReason =
  | 'device_mismatch'
  | 'expired'
  | 'not_active'
  | 'invalid_token'
  | 'session_required'
  | 'wrong_account'
  | null

interface SubscriptionState {
  type: string
  plan: string | null
  isValid: boolean
  computerName?: string
  osInfo?: string
  deviceId?: string
  activationCode?: string
  proTrialExpiresAt?: string
  endDate?: string
  validationError?: ValidationErrorReason
  setSubscription: (subscription: Partial<SubscriptionState>) => void
  clearSubscription: () => void
}

export const useSubscriptionStore = create<SubscriptionState>()(
  persist(
    (set) => ({
      type: 'free',
      plan: null,
      isValid: false,
      validationError: null,
      setSubscription: (data: Partial<SubscriptionState>): void => {
        set({ ...data })
      },
      clearSubscription: (): void => {
        set({
          type: 'free',
          plan: null,
          isValid: false,
          proTrialExpiresAt: undefined,
          endDate: undefined,
          validationError: null
        })
      }
    }),
    {
      name: 'subscription-store',
      partialize: (state) => ({
        type: state.type,
        plan: state.plan,
        isValid: state.isValid,
        computerName: state.computerName,
        osInfo: state.osInfo,
        deviceId: state.deviceId,
        activationCode: state.activationCode,
        proTrialExpiresAt: state.proTrialExpiresAt,
        endDate: state.endDate
      })
    }
  )
)
